// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"rn-z","summaryPar":"sn-z","ratingCategories":"tn-z","reviewerInfo":"un-z","reviewTypes":"vn-z","expanded":"wn-z"};